module.exports = __webpack_public_path__ + "static/HandoffPrototyping2x-25f33badf49b15d9829822f7f0df0ccd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-zeplin/HandoffPrototyping2x.jpg
// module id = 2666
// module chunks = 21098653631116